import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import {
  DisplayPictureBoxStyled,
  FamilyDisplayPictureBoxStyled,
} from './DisplayPictureStyled';
import { DisplayPictureData } from './DisplayPictureData';
import './DisplayPicture.css';

interface DisplayPictureProps {
  scope?: string;
  avatarFamilyDrawerScrollRef: any;
}

export const DisplayPicture = ({
  scope,
  avatarFamilyDrawerScrollRef,
}: DisplayPictureProps) => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [isPositionFixed, setIsPositionFixed] = useState<boolean>(false);

  const redirectLink = useSelector(
    (state: any) => state.enrollment?.authentication?.redirectLink
  );

  useEffect(() => {
    const handleScroll = () => {
      if (redirectLink === '/enrollment/profile/edit') {
        setIsScrolled(window?.scrollY > 40);
      } else if (redirectLink === '/enrollment/family') {
        setIsScrolled(avatarFamilyDrawerScrollRef?.current?.closest('.drawer-row').scrollTop > 116.2);
        setIsPositionFixed(avatarFamilyDrawerScrollRef?.current?.closest('.drawer-row').scrollTop > 148.2);
      }
    };

    const addScrollListener = () => {
      if (redirectLink === '/enrollment/profile/edit') {
        window?.addEventListener('scroll', handleScroll);
      } else if (redirectLink === '/enrollment/family') {
        const observer = new MutationObserver((mutations, obs) => {
          const drawerRowElement =
            avatarFamilyDrawerScrollRef?.current?.closest('.drawer-row');
          if (drawerRowElement) {
            drawerRowElement.addEventListener('scroll', handleScroll);
            obs.disconnect(); // Stop observing once the element is found
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }
    };

    addScrollListener();

    return () => {
      // Cleanup function to remove event listeners
      window?.removeEventListener('scroll', handleScroll);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      avatarFamilyDrawerScrollRef?.current?.removeEventListener(
        'scroll',
        handleScroll
      );
    };
  }, [avatarFamilyDrawerScrollRef, redirectLink]);

  const scrolledClass = `display-picture-box ${isScrolled ? 'scrolled' : ''}`;
  return (
    <div data-testid="display-picture-box" className={scrolledClass}>
      {redirectLink === '/enrollment/profile/edit' ? (
        <DisplayPictureBoxStyled
          scrolled={isScrolled.toString()}
          className={isScrolled ? 'scrolled' : ''}
        >
          <DisplayPictureData scope={scope} />
        </DisplayPictureBoxStyled>
      ) : redirectLink === '/enrollment/family' ? (
        <FamilyDisplayPictureBoxStyled scrolled={isScrolled.toString()} fixed={isPositionFixed.toString()}>
          <DisplayPictureData scope={scope} scrolled={isScrolled.toString()}/>
        </FamilyDisplayPictureBoxStyled>
      ) : null}
    </div>
  );
};
